import { useState, useEffect } from "react";
import { MessageCircle, CalendarCheck } from "lucide-react";

export default function FloatingCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="floating-cta"
      className={`fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <a
        data-testid="floating-whatsapp"
        href="https://wa.me/33780179467?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20Sapeur-360."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contacter par WhatsApp"
        className="grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
      >
        <MessageCircle className="h-7 w-7" />
      </a>
      <a
        data-testid="floating-demo"
        href="/contact"
        className="inline-flex items-center gap-2 rounded-full bg-[#E63946] hover:bg-[#BE123C] text-white font-bold pl-4 pr-5 py-3 shadow-lg transition-colors"
      >
        <CalendarCheck className="h-5 w-5" />
        Demander une démo
      </a>
    </div>
  );
}
